import { useAccessSessionApi } from '@client-app-sdk/hooks';
import { AccessSessionsApiGetAccessSessionAccessDetailsRequest } from '@client-app-sdk/api/v1';
import { useQuery } from '@tanstack/react-query';
import { GET_ACCESS_SESSION_DETAILS_QUERY_KEY } from './query-keys';

export default function useGetAccessSessionDetails({ id }: AccessSessionsApiGetAccessSessionAccessDetailsRequest) {
  const api = useAccessSessionApi();

  const fetchMethod = async () => {
    const result = await api.getAccessSessionAccessDetails({ id });
    return result;
  };

  return useQuery({ queryKey: [GET_ACCESS_SESSION_DETAILS_QUERY_KEY, id], queryFn: fetchMethod, cacheTime: 0 });
}
